import { type ViewMode } from './utils';

// Inline, currentColor icons so the active/hover states + dark mode all colour
// correctly (the shared GridSVG/TableSVG hardcode black fills).
const CardIcon = () => (
	<svg
		viewBox='0 0 20 20'
		fill='none'
		aria-hidden='true'
	>
		<rect
			x='3'
			y='3'
			width='6'
			height='6'
			rx='1.4'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
		<rect
			x='11'
			y='3'
			width='6'
			height='6'
			rx='1.4'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
		<rect
			x='3'
			y='11'
			width='6'
			height='6'
			rx='1.4'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
		<rect
			x='11'
			y='11'
			width='6'
			height='6'
			rx='1.4'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
	</svg>
);

const TableIcon = () => (
	<svg
		viewBox='0 0 20 20'
		fill='none'
		aria-hidden='true'
	>
		<rect
			x='3'
			y='4'
			width='14'
			height='12'
			rx='1.4'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
		<path
			d='M3 8h14M3 12h14M8 8v8'
			stroke='currentColor'
			strokeWidth='1.3'
		/>
	</svg>
);

const KanbanIcon = () => (
	<svg
		viewBox='0 0 20 20'
		fill='none'
		aria-hidden='true'
	>
		<rect
			x='3'
			y='3.5'
			width='4'
			height='13'
			rx='1'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
		<rect
			x='8.5'
			y='3.5'
			width='4'
			height='9'
			rx='1'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
		<rect
			x='14'
			y='3.5'
			width='4'
			height='6'
			rx='1'
			stroke='currentColor'
			strokeWidth='1.5'
		/>
	</svg>
);

const TreeIcon = () => (
	<svg
		viewBox='0 0 20 20'
		fill='none'
		aria-hidden='true'
	>
		<path
			d='M7 4.5h10M7 10h10M7 15.5h10'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
		<path
			d='M3.5 4.5v11M3.5 10h2.5M3.5 15.5h3.5'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<circle
			cx='3.5'
			cy='4.5'
			r='1.3'
			fill='currentColor'
		/>
	</svg>
);

const OPTIONS: { mode: ViewMode; label: string; icon: JSX.Element }[] = [
	{ mode: 'card', label: 'Card view', icon: <CardIcon /> },
	{ mode: 'table', label: 'Table view', icon: <TableIcon /> },
	{ mode: 'kanban', label: 'Board view', icon: <KanbanIcon /> },
	{ mode: 'tree', label: 'Tree view', icon: <TreeIcon /> },
];

interface IViewModeSwitchProps {
	value: ViewMode;
	onChange: (mode: ViewMode) => void;
}

/** Icon segmented control for switching how the child list renders. */
const ViewModeSwitch = ({ value, onChange }: IViewModeSwitchProps) => (
	<div
		className='qa-viewmode'
		role='tablist'
		aria-label='Choose how to view the list'
	>
		{OPTIONS.map((opt) => (
			<button
				key={opt.mode}
				type='button'
				role='tab'
				aria-selected={value === opt.mode}
				aria-label={opt.label}
				title={opt.label}
				className={`qa-viewmode__item ${value === opt.mode ? 'qa-viewmode__item--active' : ''}`}
				onClick={() => onChange(opt.mode)}
			>
				{opt.icon}
			</button>
		))}
	</div>
);

export default ViewModeSwitch;
